import apiService from '../../../services/api'

/**
 * Rub Withdraw API
 * Вывод кристаллов в рублях: СБП (по телефону и банку) и на карту РФ
 *
 * - GET /api/rub-withdraw/ — курс, способы с лимитами, банки СБП, активная заявка и история
 * - POST /api/rub-withdraw/ — создать заявку { method, amount, crystals, phone, bank_id | card, name }
 *
 * parseForbidden: 403 (disabled / deposit required / withdraw banned) разбирается вызывающим кодом
 */

/**
 * Сколько кристаллов спишется за сумму в рублях: ceil(rub × rate / 1000), BigInt — без потери точности
 * @param {number} rub — целая сумма к получению
 * @param {number} rate — crystals_per_1000_rub_net
 * @returns {number|null}
 */
export const rubToCrystals = (rub, rate) => {
  if (!Number.isSafeInteger(rub) || rub <= 0 || !Number.isSafeInteger(rate) || rate <= 0) return null
  return Number((BigInt(rub) * BigInt(rate) + 999n) / 1000n)
}

/**
 * Телефон из любой записи (+7 (911) 788-36-30, 89117883630, 9117883630) — 10 цифр без кода страны.
 * Мобильный номер РФ начинается с 9, поэтому ведущие 7/8 — это код страны
 */
export const parsePhone = (value) => {
  const raw = String(value || '').trim()
  let digits = raw.replace(/\D/g, '')
  if (raw.startsWith('+7')) digits = digits.slice(1)
  return digits.replace(/^[78]/, '').slice(0, 10)
}

// Маска +7 (911) 788-36-30 без хвостовых разделителей — чтобы стирание работало естественно
export const formatPhone = (digits) => {
  if (!digits) return ''
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)]
  let result = `+7 (${parts[0]}`
  if (parts[1]) result += `) ${parts[1]}`
  if (parts[2]) result += `-${parts[2]}`
  if (parts[3]) result += `-${parts[3]}`
  return result
}

export const isValidPhone = (digits) => /^9\d{9}$/.test(digits)

export const formatCard = (value) => String(value || '').replace(/\D/g, '').slice(0, 19).replace(/(\d{4})(?=\d)/g, '$1 ')

// 16–19 цифр и контрольная сумма по алгоритму Луна
export const isValidCard = (value) => {
  const digits = String(value || '').replace(/\D/g, '')
  if (digits.length < 16 || digits.length > 19) return false
  let sum = 0
  for (let i = 0; i < digits.length; i += 1) {
    let digit = Number(digits[digits.length - 1 - i])
    if (i % 2 === 1) {
      digit *= 2
      if (digit > 9) digit -= 9
    }
    sum += digit
  }
  return sum % 10 === 0
}

export const normalizeName = (value) => String(value || '').trim().replace(/\s+/g, ' ')

// ФИО кириллицей, от двух слов, двойная фамилия — через дефис
export const isValidName = (value) => /^[А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)*( [А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)*)+$/.test(normalizeName(value))

const fetchRubWithdrawData = () => apiService.makeRequest('/api/rub-withdraw/', { parseForbidden: true })

const createRubWithdraw = (payload) => apiService.makeRequest('/api/rub-withdraw/', {
  method: 'POST',
  parseForbidden: true,
  body: JSON.stringify(payload),
})

export default {
  fetchRubWithdrawData,
  createRubWithdraw,
}
